import { call } from 'redux-saga/effects';

import { updateArtset } from './updateArtset';
import { fetchSingleArtset } from './fetchSingleArtset';

export const updateArtsetArtistName = function* (artistName) {
  const artsetToUpdate = yield call(fetchSingleArtset);
  artsetToUpdate.Configuration.ArtistName = artistName;
  yield call(updateArtset, artsetToUpdate);
};
